import { useATTrackEvent } from '@at/consumer-web-snowplow'
import type { ComponentViewed100 } from '@at/track-types'
import type { Entities } from '@at/track-core'
import { removeMatchingEntities } from '../../utils/tracking/tracking'

interface TrackViewInteractionArgs {
    additionalEntities: Entities
    entitiesToReplace?: Entities
}

export type TrackViewInteractionCallback = (args?: TrackViewInteractionArgs) => void

export const useTrackViewedInteraction = (componentNameLabel: string): TrackViewInteractionCallback => {
    const componentViewedEntity: ComponentViewed100 = {
        SCHEMA_KEY: 'ComponentViewed100',
        component_name: componentNameLabel,
    }

    const fireTrackInteraction = useATTrackEvent()

    return ({ additionalEntities, entitiesToReplace } = { additionalEntities: [], entitiesToReplace: [] }) => {
        fireTrackInteraction({
            fireEventEntity: componentViewedEntity,
            customiseEntities: (currentEntities: Entities) => {
                const entitiesToTrack = entitiesToReplace
                    ? removeMatchingEntities(currentEntities, entitiesToReplace)
                    : currentEntities
                if (additionalEntities) {
                    return [...entitiesToTrack, ...additionalEntities]
                } else {
                    return entitiesToTrack
                }
            },
        })
    }
}
